import { Item, List } from './styles'
import { ArticleListProps } from './types'

export function ArticleList({
  type,
  items,
  paddingLeft = '32px',
  marginTop = '32px',
  gap = '8px',
  fontSize,
  fontWeight,
  textAlign = 'left',
  gapMobile,
  ...listProps
}: ArticleListProps) {
  return (
    <List
      paddingLeft={paddingLeft}
      marginTop={marginTop}
      gap={gap}
      as={type}
      gapMobile={gapMobile}
      textAlign={textAlign}
      {...listProps}
    >
      {items.map((item, index) => (
        <Item key={index} fontSize={fontSize} fontWeight={fontWeight}>
          {item}
        </Item>
      ))}
    </List>
  )
}
